import { render } from "./Catalogue.vue?vue&type=template&id=5c68b53c"
import script from "./Catalogue.vue?vue&type=script&lang=js"
export * from "./Catalogue.vue?vue&type=script&lang=js"

import "./Catalogue.vue?vue&type=style&index=0&id=5c68b53c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__